const getScrollLeft = () => (window.pageXOffset || document.body.scrollLeft);

const getScrollTop = () => (window.pageYOffset || document.body.scrollTop);


export {getScrollLeft, getScrollTop};
